#import "../fragments/ImageFragment.gql"
#import "../fragments/URLFragment.gql"
fragment SearchPerformerFragment on Performer {
  id
  name
  disambiguation
  deleted
  gender
  aliases
  country
  career_start_year
  career_end_year
  scene_count
  birth_date
  urls {
    ...URLFragment
  }
  images {
    ...ImageFragment
  }
  # Used for search dropdowns and other areas
  # where the image needs to be readable at small scale
  thumbnail {
    url
  }
  is_favorite
}
